import { render } from "./Attacker.vue?vue&type=template&id=365f785c"
import script from "./Attacker.vue?vue&type=script&lang=js"
export * from "./Attacker.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/statistics/player/Attacker.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "365f785c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('365f785c', __exports__)) {
    api.reload('365f785c', __exports__)
  }
  
  module.hot.accept("./Attacker.vue?vue&type=template&id=365f785c", () => {
    api.rerender('365f785c', render)
  })

}


export default __exports__